import { render, staticRenderFns } from "./community-notification.vue?vue&type=template&id=6fd81146&scoped=true&"
import script from "./community-notification.vue?vue&type=script&lang=js&"
export * from "./community-notification.vue?vue&type=script&lang=js&"
import style0 from "./community-notification.vue?vue&type=style&index=0&id=6fd81146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd81146",
  null
  
)

export default component.exports